<template>
  <div class="MerchantNotification">
    <div class="pt-30 pl-30">
				<el-checkbox v-model="checkAll" @change="handleCheckAllChange" class="font-14">全选</el-checkbox>
					<span class="ml-100 font-14 color-blue cursor" @click="read">标记已读</span>
					<span class="ml-50 font-14 color-blue cursor" @click="remove">删除</span>

					<el-checkbox-group v-model="checkedCities" @change="handleCheckedOptionChange" class="mt-20">
						<div v-for="item in messageList" :key="item.id" class="option">
							<el-checkbox :label="item.id"/>
              <div class="infoDiv cursor" @click="clickItem(item)">
                <div :class="item.read?'infoTitle2':'infoTitle'">{{item.noticeTitle}}</div>
								<div class="font-12 color-9"><span>时间：{{item.gmtCreate | time}}</span> <span class="ml-20">类型：{{item.typeName}}</span></div>
              </div>
						</div>
					</el-checkbox-group>

					<div class="countBlank mt-50 ml-40" v-if="messageList.length == 0">
						<img src="@/assets/empty.png" alt="" />
						<p class="color-9 mt-15">消息空空如也</p>
					</div>

				<el-pagination v-if='total>0' class="tar mr-30 mt-20" :current-page="form.pageIndex" :page-size='form.pageSize' :total='total' layout="prev , pager, next, jumper" @current-change="handleCurrentChange">
					<!-- 分页组件 -->
				</el-pagination>



        <el-dialog title="调价明细" :visible.sync="dialogInfo" width="70%">
          <div style="padding:0 20px">
             <el-table :data="priceList">
              <el-table-column property="" label="类型" width="70" align="center">
                <template slot-scope="{row}">
                  <div>
                    {{row.operation=='add'?'新增':'修改'}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="" label="商品名称/编码" width="400">
                <template slot-scope="{row}">
                  <div>
                    <div>商品名称：{{row.skuName}}</div>
                    <div>商品编码：{{row.goodsNo}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="oldPrice" label="调整前价格" align="center">
                <template slot-scope="{row}">
                  <div>
                    {{row.oldPrice?row.oldPrice:"--"}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="newPrice" label="调整后价格" align="center">
                <template slot-scope="{row}">
                  <div v-if="row.operation=='add'">{{row.newPrice}}</div>
                  <div v-else>
                    <span :class="row.isUp?'redText':'greenText'">{{row.newPrice}}</span>
                    <i v-if="row.isUp" class="el-icon-caret-top redText font-16"></i>
                    <i v-else class="el-icon-caret-bottom greenText font-16"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="unitName" label="计价单位" width="100" align="center"></el-table-column>
              <el-table-column property="gmtStart" label="生效时间" align="center"></el-table-column>
              <el-table-column property="gmtEnd" label="失效时间" align="center" ></el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogInfo = false">确 定</el-button>
          </div>
        </el-dialog>
			</div>
  </div>
</template>

<script>
import { parseTime, computeNumber } from "@/utils";
import { axiosApi, basePath } from "~/api/api";
import { mapMutations } from "vuex"
import { getNotice, delNotice, readNotice, getPriceAdjustmentTable } from "~/api/messageCenter";
export default {
  data(){
    return {
      form:{
        pageIndex:1,
        pageSize:10,
      },
      checkAll: false,
      checkedCities: [],
      messageList: [],
      msgId: [], //哪条消息需要标为已读
      total: null,

      dialogInfo:false,
      priceList:[],
    }
  },
  mounted(){
    this.getList()
  },
  activated() {
    
  },
  methods: {
    // 获取列表
    getList(){
      getNotice(this.form).then(res=>{
        this.messageList = res.elements ? res.elements : [];
        this.total = res.totalCount;
        this.checkAll = false;
        this.checkedCities = [];
        this.msgId = []
      }).catch(err=>{

      })
    },
    // 分页
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.checkedCities = [];
      this.msgId = []
      this.checkAll = false;
      this.getList()
    },




    ...mapMutations({
      "mesnum": "mesnum"
    }),

    handleCheckAllChange(event) {
      if(this.checkAll) {
        this.messageList.forEach(item => {
          this.checkedCities.push(item.id)
        });
        this.msgId = this.checkedCities
      } else {
        this.checkedCities = [];
        this.msgId = this.checkedCities
      }
    },
    handleCheckedOptionChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.messageList.length;
      this.msgId = this.checkedCities
    },
    read() {
      if(this.msgId.length > 0) {
        this.readNotice(this.msgId)
      }else{
        this.$message({
          type: 'info',
          message: '请选择需要标记为已读的消息!',
          duration: 1000
        });
      }
    },
    readNotice(ids){
      const body = {
        traderNoticeRecordIds: ids,
        noticeType: 'currency', // 订单order，商户currency，活动activity
      };
      readNotice(body).then(res=>{
        this.$message({
          type: 'success',
          message: '操作成功!',
          duration: 1000
        });
        this.getList()
      }).catch(err=>{

      })
    },
    
    remove() {
      if(this.msgId.length !== 0) {
        this.$confirm('您是否要删除此条消息？', '提示信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delNotice()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
            duration: 1000
          });
        })
      } else {
        this.$message({
          type: 'info',
          message: '请选择需要删除的消息',
          duration: 1000
        });
      }
    },
    delNotice(){
      var data = {
        traderNoticeRecordIds: this.msgId,
        noticeType: 'currency', // 订单order，商户currency，活动activity
      }
      delNotice(data).then(res=>{
        this.$message({
          type: 'success',
          message: '删除成功!',
          duration: 1000
        });
        this.form.pageIndex = 1
        this.getList()
      }).catch(err=>{

      })
    },
    clickItem(item){
      this.readNotice([item.id]) // 已读
      if(item.type==1){ // 通用通知
        // 详情
        this.$router.push(basePath + '/search1/messageDetail/'+item.traderNoticeId)
      }else if(item.type == 2){ // 调价通知
        this.getPriceAdjustmentTableList(item.typeObjectId)
      }else if(item.type == 3){ // 月度对账单通知
        this.$router.push(basePath+'/myMonthStatementDetails?isMy=true&id='+item.typeObjectId)
      }
    },

    getPriceAdjustmentTableList(id){
      getPriceAdjustmentTable({id:id}).then(res=>{
        this.dialogInfo = true
        if(res){
          var list = res.map(item=>{
            if(item.oldPrice){
              if(item.oldPrice<item.newPrice){
                item.isUp = true
              }else{
                item.isUp = false
              }
              return item
            }else{
              return item
            }
          })
          this.priceList = list||[]
        }

      }).catch(err=>{
        
      })
    },
  }
}
</script>

<style lang="less">
.MerchantNotification{
    .title:hover,
		.option:hover .text-decoration{
			text-decoration: underline;
		}
		.option {
			display: flex;
			padding-top: 20px;
			.el-checkbox{
				margin-top: 10px;
				flex: 0 0 auto;
				.el-checkbox__label{
					display: none ;
				}
			}
      .infoDiv{
        flex: 1;
        font-size: 14px;
        margin-left: 20px;
        .infoTitle{
          color: #20a0ff;
        }
        .infoTitle2{
          color: #000;
        }
      }
		}
		// .message-content{
		// 	display: inline-block;
		// 	vertical-align: middle;
		// 	width: 100%;
		// }
		.text {
			border-bottom: 1px solid #ddd;
		}
		.countBlank {
			width: 900px;
			height: 300px;
			padding-top: 100px;
			text-align: center;
		}
    .redText{
      color: #F56C6C;
    }
    .greenText{
      color: #67C23A;
    }
}
</style>